import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Electronics.css';

// Import images for features
import chipsetImage from '../Assets/chip.jpg';
import bluetoothImage from '../Assets/bluetooth-integration (2).jpg';
import wifiImage from '../Assets/wifi rr.jpg';
import designImage from '../Assets/design2.jpg';
import designdev from '../Assets/design d.jpg';

const Electronics = () => {
  const navigate = useNavigate();
  const heroRef = useRef(null);
  const featuresRef = useRef(null);
  const contactRef = useRef(null);
  const [isFeaturesHighlighted, setIsFeaturesHighlighted] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('ce-animate');
            entry.target.classList.add('ce-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (heroRef.current) observer.observe(heroRef.current);
    if (featuresRef.current) observer.observe(featuresRef.current);
    if (contactRef.current) observer.observe(contactRef.current);

    return () => {
      if (heroRef.current) observer.unobserve(heroRef.current);
      if (featuresRef.current) observer.unobserve(featuresRef.current);
      if (contactRef.current) observer.unobserve(contactRef.current);
    };
  }, []);

  const handleExploreNowClick = () => {
    try {
      if (featuresRef.current) {
        // Primary scroll method
        featuresRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Fallback scroll method
        const offsetTop = featuresRef.current.getBoundingClientRect().top + window.pageYOffset - 80; // Adjust for header
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        // Highlight effect
        setIsFeaturesHighlighted(true);
        setTimeout(() => setIsFeaturesHighlighted(false), 2000); // Highlight for 2 seconds
      } else {
        console.error('featuresRef is not attached to an element');
      }
    } catch (error) {
      console.error('Error in handleExploreNowClick:', error);
    }
  };

  const handleGetInTouchClick = () => {
    navigate('/contact');
  };

  return (
    <div className="ce-electronics-container">
      {/* Hero Section */}
      <header className="ce-hero-section1" ref={heroRef}>
        <div className="ce-container">
          <div className="ce-hero-content2">
            <h1 className="ce-hero-title2">Consumer Electronics</h1>
            <p className="ce-hero-subtitle2">
              Innovate with advanced chipset modules, Bluetooth, WiFi assembly, and design development.
            </p>
            <div className="ce-button-wrapper">
              <h3 className="ce-button-heading">Discover Cutting-Edge Solutions</h3>
              <button className="ce-hero-button" onClick={handleExploreNowClick}>
                Explore Now
              </button>
            </div>
          </div>
          <div className="ce-hero-graphic"></div>
        </div>
      </header>

      {/* Features Section */}
      <section className="ce-features-section" ref={featuresRef}>
        <div className="ce-container">
          <h2 className={`ce-section-title ${isFeaturesHighlighted ? 'ce-highlight' : ''}`}>
            Our Expertise
          </h2>
          <div className="ce-features-grid">
            <div className="ce-feature-card">
              <img src={chipsetImage} alt="Chipset Modules" className="ce-feature-image" />
              <h3 className="ce-feature-title">Chipset Modules</h3>
              <p className="ce-feature-description">
                Advanced chipsets power next-gen devices with high performance and efficiency.
              </p>
            </div>
            <div className="ce-feature-card">
              <img src={bluetoothImage} alt="Bluetooth Technology" className="ce-feature-image" />
              <h3 className="ce-feature-title">Bluetooth</h3>
              <p className="ce-feature-description">
                Seamless wireless connectivity for smart devices with low-energy solutions.
              </p>
            </div>
            <div className="ce-feature-card">
              <img src={wifiImage} alt="WiFi Assembly" className="ce-feature-image" />
              <h3 className="ce-feature-title">WiFi Router</h3>
              <p className="ce-feature-description">
                Precision assembly for reliable, high-speed WiFi modules.
              </p>
            </div>
            <div className="ce-feature-card">
              <img src={designImage} alt="Design Development" className="ce-feature-image" />
              <h3 className="ce-feature-title">Design Assembling</h3>
              <p className="ce-feature-description">
                Innovative design processes for user-friendly electronics.
              </p>
            </div>
            <div className="ce-feature-card">
              <img src={designdev} alt="Design Development" className="ce-feature-image" />
              <h3 className="ce-feature-title">Design Development</h3>
              <p className="ce-feature-description">
                Innovative design processes for user-friendly electronics.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="ce-contact-section" ref={contactRef}>
        <div className="ce-container">
          <h2 className="ce-section-title">Future-Proof Your Innovation</h2>
          <p className="ce-contact-text">
            Ready to lead in consumer electronics? Contact us to explore our solutions.
          </p>
          <button className="ce-contact-button1" onClick={handleGetInTouchClick}>
            Get in Touch
          </button>
        </div>
      </section>
    </div>
  );
};

export default Electronics;